export const listConstant = {
  childHeader: 'Revalidation list',
  addButtonLable: 'New Plan',
  datePickerLabel: 'Search By Year',
  modalTile: 'CREATE NEW PLAN',
};

export const createConstant = {
  childHeader: 'Revalidation list',
  theadHeader: ' Revalidation',
  extracolSpan: 3,
};

export const apiConstant = {
  // list api url
  gettableListDataurl: 'revalidationPlanRoute/monthlylist',
  deleteListurl: 'revalidationPlanRoute',
  getListPlanByid: 'revalidationPlanRoute',
  createListPlanByid: 'revalidationPlanRoute',

  // -----plan--
  sync: 'revalidationPlanRoute/handleSync',
  getAllPlanById: 'revalidationPlanRoute/allplansbyid',
  upadateCreateAllPlan: 'revalidationPlanRoute/allplansCreateUpdate',
  maintenancePlanDeleteBulkById:
    'revalidationPlanRoute/maintenancePlanDeleteBulkById',
};

export const tilesConstant = {
  childHeaderText: 'REVALIDATION',
};

export const navigationConstant = {
  planRouter: '/common/revalidationPlanCreate',
};
